<template>
  <v-row justify="center" :class="{ invisible: !isDialoglVisible }">
    <v-dialog v-model="isDialoglVisible" persistent max-width="756">
      <v-card>
        <v-card-title class="headline">
          <span>{{ $i18n.t('dialog.header.addingAttachment') }}</span>
        </v-card-title>
        <v-form ref="form" v-model="isValid" @submit.prevent="save" id="form--attachment">
          <v-card-text>
            <template>
              <v-row no-gutters class="dropdown mb-3">
                <v-col cols="12" xs="12">
                    <v-row class="justify-center">
                      <v-col cols="auto">
                        <v-subheader class="title pa-0 justify-center">{{
                          $i18n.t('offer.attachments.drop')
                        }}</v-subheader>
                        <v-subheader style="height: 30px" class="subtitle-2 justify-center pa-0">{{
                          $i18n.t('offer.attachments.or')
                        }}</v-subheader>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col cols="auto pt-0">
                        <file-upload :size="1024 * 1024 * 10" v-model="files" ref="upload" :drop="true" multiple>
                          <v-btn small class="primary">{{ $i18n.t(`offer.attachments.selectFile`) }}</v-btn>
                        </file-upload>
                      </v-col>
                    </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters style="max-height: 35vh; overflow: auto" class="pt-3">
                <v-row no-gutters v-for="(file,idx) of files" :key="idx" align="center">
                  <v-col cols="3" xs="12">
                    <v-text-field
                      readonly
                      outlined
                      v-model="file.name"
                      :rules="rules"
                      :label="$i18n.t('offer.attachments.name')"
                      required
                    />
                  </v-col>
                  <v-col cols="4" xs="12" class="px-2">
                    <v-text-field
                      outlined
                      v-model="file.pl"
                      :rules="rules"
                      :label="$i18n.t('offer.attachments.polishDesc')"
                      required
                    />
                  </v-col>
                  <v-col cols="4" xs="12" class="px-2">
                    <v-text-field
                      outlined
                      v-model="file.en"
                      :rules="rules"
                      :label="$i18n.t('offer.attachments.englishDesc')"
                      required
                    />
                  </v-col>
                  <v-col cols="1" xs="12" class="pb-6 pl-3">
                    <v-icon @click="files.splice(idx,1)">mdi-delete</v-icon>
                  </v-col>
                </v-row>
              </v-row>
              <template v-if="attachmentEntitiesTypes && attachmentEntitiesTypes.length > 0 && files.length > 0">
                <v-row no-gutters>
                  <v-col cols="3">{{ $i18n.t('offer.attachments.assignAttachmentTo') }}:</v-col>
                  <v-col cols="4">
                    <v-radio-group
                      class="my-0 py-0"
                      v-model="attachmentEntityType"
                      :rules="rules"
                      @change="attachmentEntityId = ''"
                    >
                      <v-radio
                        v-for="(attEntityType, idx) of attachmentEntitiesTypes"
                        :key="idx"
                        :label="attEntityType.label"
                        :value="attEntityType"
                        color="primary"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="5" v-if="attachmentEntityType && attachmentEntityType.items && attachmentEntityType.items.length > 0" class="pl-2">
                    <v-select
                      v-model="attachmentEntityId"
                      :items="attachmentEntityType.items"
                      item-text="text"
                      item-value="value"
                      hide-details
                      outlined
                      :rules="rules"
                    />
                  </v-col>
                </v-row>
              </template>
            </template>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="primary" text @click="close">{{ $i18n.t('dialog.confirmation.close') }}</v-btn>
            <v-btn
              :disabled="!isValid || files.length < 1"
              color="primary"
              text
              :title="$i18n.t('dialog.confirmation.save')"
              type="submit"
              form="form--attachment"
              >{{ $i18n.t('dialog.confirmation.save') }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import FileUpload from 'vue-upload-component';

export default {
  name: 'AddAttachmentDialog',
  components: {
    FileUpload
  },
  data: () => ({
    attachmentEntityId: '',
    attachmentEntityType: '',
    name: '',
    files: [],
    en: '',
    pl: '',
    isValid: false,
    isDialoglVisible: false
  }),
  props: {
    attachmentEntitiesTypes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    entityId: {
      required: true,
      type: [String, Number]
    },
    entityType: {
      type: String,
      default: ''
    }
  },
  computed: {
    rules() {
      return [v => !!v || this.$i18n.t('default.ruleNoEmpty')];
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.files = [];
      this.isDialoglVisible = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        for (const file of this.files) {
          const formData = new FormData();
          const timeStamp = new Date();
          const entityId = this.attachmentEntityId || this.attachmentEntityId == '0' ? this.attachmentEntityId : this.entityId;
          const entityType = this.attachmentEntityId || this.attachmentEntityId == '0' ? this.attachmentEntityType.value : this.entityType;
          formData.append('pl', file.pl);
          formData.append('en', file.en);
          formData.append('entity_id', entityId);
          formData.append('entity_type', entityType);
          formData.append('file', file.file);
          const payload = {
            formData,
            progressInfo: { id: file.id, pl: file.pl, en: file.en, name: file.name, entityId, entityType, timeStamp }
          };
          this.$root.$emit('uploadFile', payload);
        }
        this.close();
      }
    },
    openDialog() {
      this.isDialoglVisible = true;
    },
    removeFile() {
      // console.log(this.$refs);
      // this.$refs.upload.remove(this.files[0]);
      this.files = [];
    }
  },
  beforeMount() {
    this.entityType = this.$options.parent.$props.entityType;
  },
  mounted() {
    this.$root.$on('openAttachmentsDialog', this.openDialog);
  }
};
</script>

<style>
.dropdown {
  border-radius: 5px;
  background-color: rgb(224, 224, 224);
}
.invisible {
  display: none;
}
</style>
